import m from "./ghl-ui.es1506.js";
import a from "./ghl-ui.es1466.js";
function u(t) {
  a(1, arguments);
  var e = m(t), r = e.getTime();
  return r;
}
export {
  u as default
};
